export const MESSAGE = {
    MES1: 'Hello world',
};

export const REGEX = {
    PERCENT_NINETY_NINE: new RegExp('^([1-9]([0-9])?|0)(\\.[0-9]{1,2})?$'),
};

export const FILE_ACCEPT = {
    IMAGE: 'image/*',
    PDF: 'application/pdf',
    EXCEL: 'application/vnd.ms-excel',
    EXCEL_X: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    WORD: 'application/msword',
    WORD_X: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    POWERPOINT: 'application/vnd.ms-powerpoint',
    POWERPOINT_X: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    TEXT: 'text/plain',
    ZIP: 'application/zip,application/x-zip-compressed,application/octet-stream',
    CSV: 'text/csv',
    ALL: '*/*',
};

export const FILE_EXTENSION = {
    [FILE_ACCEPT.IMAGE]: ['png', 'jpeg', 'jpg'],
    [FILE_ACCEPT.PDF]: ['pdf'],
    [FILE_ACCEPT.EXCEL]: ['xls'],
    [FILE_ACCEPT.EXCEL_X]: ['xlsx'],
    [FILE_ACCEPT.WORD]: ['doc'],
    [FILE_ACCEPT.WORD_X]: ['docx'],
    [FILE_ACCEPT.POWERPOINT]: ['ppt'],
    [FILE_ACCEPT.POWERPOINT_X]: ['pptx'],
    [FILE_ACCEPT.TEXT]: ['txt'],
    [FILE_ACCEPT.ZIP]: ['zip'],
    [FILE_ACCEPT.ZIP]: ['zip'],
    'application/zip': ['zip'],
    'application/x-zip-compressed': ['zip'],
    'application/octet-stream': ['zip'],
    [FILE_ACCEPT.CSV]: ['csv'],
    [FILE_ACCEPT.ALL]: [],
};

export const ENV = {
    TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000'),
    GOOGLE_MAP_API_KEY: process.env.REACT_APP_GOOGLE_MAP_API_KEY || '',
    SOCKET_BASE: process.env.REACT_APP_SOCKET_END_POINT ?? 'wss://127.0.0.1',
    UI_CONTROL_NUMBER_OF_UPLOAD_FILE_EACH: process.env.REACT_APP_UI_CONTROL_NUMBER_OF_UPLOAD_FILE_EACH,

    //CU-005-01-02
    // FILE_MAX_SIZE_CU_005_01_02: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_005_01_02 ?? 2,
    // FILE_TYPE_CU_005_01_02: process.env.REACT_APP_UI_CONTROL_ACCEPTED_FILE_TYPE_CU_005_01_02 ?? 'image/*',
    //CU-005-02
    // FILE_MAX_SIZE_CU_005_02: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_005_02 ?? 2,
    // FILE_TYPE_CU_005_02: process.env.REACT_APP_UI_CONTROL_ACCEPTED_FILE_TYPE_CU_005_02 ?? 'image/*',

    //CU_031_01
    FILE_MAX_SIZE_CU_031_01: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_031_01 ?? 2,
    FILE_TYPE_CU_031_01: process.env.REACT_APP_UI_CONTROL_ACCEPTED_FILE_TYPE_CU_031_01 ?? 'image/*',

    //CU_012_01
    FILE_MAX_SIZE_CU_012_01: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_012_01 ?? 2,
    FILE_MAX_NUMBER_CU_012_01: process.env.REACT_APP_UI_CONTROL_MAX_FILE_COUNT_CU_012_01 ?? 5,
    FILE_TYPE_CU_012_01: `${FILE_ACCEPT.IMAGE},${FILE_ACCEPT.PDF},${FILE_ACCEPT.EXCEL},${FILE_ACCEPT.EXCEL_X},${FILE_ACCEPT.WORD},${FILE_ACCEPT.WORD_X},${FILE_ACCEPT.POWERPOINT},${FILE_ACCEPT.POWERPOINT_X},${FILE_ACCEPT.TEXT},${FILE_ACCEPT.ZIP}`,

    //CU_043_01
    FILE_MAX_SIZE_CU_043_01: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_043_01 ?? 2,
    FILE_MAX_NUMBER_CU_043_01: process.env.REACT_APP_UI_CONTROL_MAX_FILE_COUNT_CU_043_01 ?? 10,
    FILE_TYPE_CU_043_01: process.env.REACT_APP_UI_CONTROL_ACCEPTED_FILE_TYPE_CU_043_01 ?? 'image/*,application/pdf',

    //CU_061_01
    FILE_MAX_SIZE_CU_061_01: process.env.REACT_APP_UI_CONTROL_MAXIMUM_UPLOAD_FILE_SIZE_MB_CU_061_01 ?? 2,
    FILE_MAX_NUMBER_CU_061_01: process.env.REACT_APP_UI_CONTROL_MAX_FILE_COUNT_CU_061_01 ?? 10,
    FILE_TYPE_CU_061_01: process.env.REACT_APP_UI_CONTROL_ACCEPTED_FILE_TYPE_CU_061_01 ?? 'image/*,application/pdf',

};

export const TYPE_CONTENT = {
    APPLICATION_JSON: 'application/json',
    MULTIPART_FORM_DATA: 'multipart/form-data',
};

export const SCREEN_NAME = {
    'CU-010-02': '売却シミュレーション',
    'CU-051-02': 'キャッシュフローシミュレーション',
    'CU-052-02': '借入金シミュレーション',
    'CU-053-02': '損益分岐シミュレーション',
    'CU-058-02': 'キャッシュフローシミュレーション',
};

export const FILE_UPLOAD = {
    //CU-005-01-02
    FILE_MAX_SIZE_CU_005_01_02: 2,
    FILE_TYPE_CU_005_01_02: 'image/jpg,image/png,image/jpeg,application/pdf',
    //CU-005-02
    FILE_MAX_SIZE_CU_005_02: 2,
    FILE_TYPE_CU_005_02: 'image/jpg,image/png,image/jpeg,application/pdf',
}

export const CURRENT_SITUATION = {
    "10": "賃貸中",
    "20": "居住中",
    "30": "転貸中",
    "40": "空室"
};

export const LINK_URL = {
    // 査定の流れを確認する
    CHECK_ASSESSMENT_METHOD: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#assessment-process',

    // 入札の詳しく
    REGISTER_BID_PRICE_DETAIL: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#bidding',

    // 落札の支払い方法の詳しく
    PAYMENT_METHOD_DETAIL: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#payment-method',

    // その他費用について詳しく
    RESULT_BEFORE_PURCHASING_DETAIL: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#other-costs',

    // 賃貸管理の詳しく
    MANAGEMENT_RENT_DETAIL: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#rental-management',

    // その他費用について詳しく (CU-058-02)
    ABOUT_OTHER_COSTS_DETAIL: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview#other-costs',

    // 利用規約URL
    TERM_OF_SERVICE: 'https://nippon-rebax.co.jp/app-term/?user_agent=webview',

    // プライバシーポリシー
    PRIVACY_POLICY: 'https://nippon-rebax.co.jp/app-privacy-policy/?user_agent=webview',

    // 個人情報の取り扱いについて
    TERMS_OF_PRIVACY: 'https://nippon-rebax.co.jp/app-privacy/?user_agent=webview',

    // FAQ
    FAQ: 'https://nippon-rebax.co.jp/app-faq/?user_agent=webview',

    // 不動産よくある質問
    REAL_ESTATE_FAQ_URL: 'https://nippon-rebax.co.jp/real-estate-faq/?user_agent=webview',
}